export default {
  title: 'Alumni Management',
  menu: 'Alumni Management',
  label: {
    email: 'Email',
    phone: 'Phone',
    name: 'Name',
    status: 'Status',
    Active: 'Active',
    InActive: 'Inactive',
    excelInput: 'EXCEL File: ',
    Pending: 'Pending',
    addAlumni: 'Add Alumni',
    editAlumni: 'Edit Alumni',
    birthday: 'Birthday',
    isEnabled: 'Is Enabled'
  },
  placeholder: {
    email: 'Please input email',
    phone: 'Please input phone',
    name: 'Please input name',
    birthday: 'Please select birthday'
  },
  btn: {
    selectFile: 'Browse',
    upload: 'Upload Alumni',
    downloadTemplate: 'Download Template',
    fleshData: 'Refresh',
    cancelUpload: 'Cancel',
    ConfirmUpload: 'Confirm',
    addAlumni: 'Add Alumni'
  },
  message: {
    uploadTip: 'You can only upload a excel file',
    uploadError: 'Upload failed, please upload again',
    uploadSuccess: 'Upload success {successCount} count, fail {failCount} count',
    refreshSuccess: 'Flesh alumni data successfully',
    refreshError: 'It is refreshed today, please try again tomorrow',
    refreshTip: 'The alumni tag will be automatically updated after 0:00 based on the latest table.',
    missEmailOrPhone: 'Fill in at least one email address or one mobile phone',
    optionSuccess: 'Option Success',
    optionField: 'Option Field',
    alumniIsExisted: 'Email or phone is already existed'
  }
}
